module.exports = __webpack_public_path__ + "static/media/profitfy-logo.0b8c705a.svg";